module.exports = __webpack_public_path__ + "media/images/gifts/books/sug_livros_6-4cbc68ea8f3e2ccefb469e95b2a870c0.jpeg";